// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"f35a2add","732":"6edfce58","977":"8219f579"}[chunkId] + ".chunk.js";
};